














































































































import * as _ from "lodash"

import {Vue, Component, Lifecycle, Prop, p, Watch} from 'av-ts'

import FullCard from './CardViews/FullCard.vue'
import TinyCard from './CardViews/TinyCard.vue'
import CardListEntry from './CardViews/CardListEntry.vue'
import CardArt from './CardViews/CardArt.vue'

import {Card} from '../deckard/models/Card'

@Component({
    components: {'TinyCard' : TinyCard, 'CardListEntry': CardListEntry,
                 'CardArt': CardArt,
                 'contextMenu': require('vue-context-menu') }
})
export default class CardGrid extends Vue
{
    @Prop cards:any = p(
    {
        type: Array,
        required: true,
        default()
        {
            return new Array<Card>();
        }
    })

    @Prop showAllText: any = p(
    {
        type: Boolean,
        required: false,
        default()
        {
            return true;
        }
    })

    groupedOverride: any = undefined;
    @Prop isGrouped: any = p(
    {
        type: Boolean,
        required: false,
        default()
        {
            return false;
        }
    })

    viewMode: string = "list";
    textFilter: string = "";
    sorting: string = "Name";
    showAllFullText: boolean = false;

    showText: any = {};
    cardQty: any = {};

    rightClickedCard: any = {};

    get shouldGroup()
    {
        return this.groupedOverride != undefined ? this.groupedOverride : this.isGrouped;
    }

    set shouldGroup(newValue)
    {
        this.groupedOverride = newValue;
    }

    get hiddenCardCount()
    {
        return this.cards.length - this.sortedCards.length;
    }

    @Watch('shouldGroup')
    groupHandler(newVal, oldVal)
    {
        this.calcCardQty();
    }

    calcCardQty()
    {
        if (this.shouldGroup) 
        {
            this.cardQty = _.groupBy(this.cards, function(card: Card)
            {
                return card.multiverseid;
            });
        }
        else
        {
            this.cardQty = {};
        }
    }

    @Watch('cards')
    cardsHandler(newVal, oldVal)
    {
        this.showText = {};
        this.calcCardQty();
    }

    onCtxOpen(vars)
    {
        this.rightClickedCard = vars;
    }

    shouldShowText(multiverseid)
    {
        if (this.showAllText)
        {
            return true;
        }

        if (this.showText[multiverseid] == undefined)
        {
            return false;
        }
        else
        {
            return this.showText[multiverseid];
        }
    }

    getCardQuantity(multiverseid)
    {
        if (this.cardQty[multiverseid] == undefined)
        {
            return 1;
        }
        else
        {
            return this.cardQty[multiverseid].length;
        }
    }

    addToDeck(card)
    {
        this.$store.commit('deck/addToDeck', (card == undefined ? this.rightClickedCard : card));
    }

    removeFromDeck()
    {
        this.$store.commit('deck/removeFromDeck', this.rightClickedCard);
    }

    removeAllFromDeck()
    {
        this.$store.commit('deck/removeAllFromDeck', this.rightClickedCard);
    }

    goToGatherer()
    {
        window.open("http://gatherer.wizards.com/Pages/Card/Details.aspx?multiverseid=" + this.rightClickedCard.multiverseid, "_blank");
    }

    goToTCG()
    {
        window.open("http://shop.tcgplayer.com/productcatalog/product/show?ProductName=" + encodeURI(this.rightClickedCard.name), "_blank");
    }

    searchAll()
    {
        this.$emit("searchAll", this.rightClickedCard);
    }

    showFullText(multiverseid)
    {
        if (this.showAllText) { return; }
        var newVal = !(this.shouldShowText(multiverseid));

        this.$set(this.showText, multiverseid, newVal);
    }

    containsAny(lowercaseFilter, input)
    {
        if (lowercaseFilter.length == 0) { return true; }

        input = input.toLowerCase();

        return _.every(lowercaseFilter, function(word)
        {
            return input.indexOf(word) > -1;
        });
    }

    get sortedCards()
    {
        let sorting: string = this.sorting;
        let textFilter: string = this.textFilter;
        let containsAny = this.containsAny;

        let filteredCards = this.cards;

        if (textFilter.length > 0)
        {
            filteredCards = _.filter(filteredCards, function(element: Card)
            {
                var lowercaseFilter = textFilter.toLowerCase().split(" ");

                var textContains = (element.text != undefined ? containsAny(lowercaseFilter, element.text) : false);
                var nameContains = containsAny(lowercaseFilter, element.name);
                var typeContains = containsAny(lowercaseFilter, element.type);

                return textContains || nameContains || typeContains;
            });
        }

        var rarityOrder = ["Basic Land", "Common", "Uncommon", "Rare", "Special", "Mythic Rare"];

        filteredCards = _.sortBy(filteredCards, function(element: Card)
        {
            switch (sorting)
            {
                case "Name":
                    return element.name;
                case "CMC":
                    return (element.cmc == undefined ? -11 : element.cmc);
                case "Color":
                    return (element.colorIdentity == undefined ? "" : element.colorIdentity);
                case "Type":
                    return element.type;
                case "Rarity":
                    return rarityOrder.indexOf(element.rarity);
                case "Power":
                    return element.power;
                case "Toughness":
                    return element.toughness;
                default:
                    return "";
            }
            
        });

        if (this.shouldGroup)
        {
            filteredCards = _.sortedUniqBy(filteredCards, function(card: Card)
            {
                return card.multiverseid;
            });
        }

        return filteredCards;
    }

    // lifecycle hook
    @Lifecycle mounted()
    {
        
    }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/CardGrid.vue